import { PartnerCard } from "./PartnerCard";

export { PartnerCard };
